<template>
  <div>
    <main-nav-bar />
    <hero :hero="heroSolid" />
    <Section :content="whatIsSolid" />
    <Section :content="ownYourData" />
    <section-more-secure />
    <Section :content="interoperable" />
    <SectionSecureSharing />
    <Section :content="usesW3c" />
    <call-to-action />
    <gmx-footer />
  </div>
</template>

<script>
// @ is an alias to /src
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import SectionMoreSecure from '@/components/section-more-secure.vue';
import SectionSecureSharing from '@/components/section-secure-sharing.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
export default {
  name: 'solid',
  components: {
    MainNavBar,
    Hero,
    Section,
    SectionMoreSecure,
    SectionSecureSharing,
    CallToAction,
    GmxFooter
  },
  data() {
    return { 
      heroSolid: { 
        eyebrow: '',
        header: 'Advancing Web Standards with Solid',
        subheader: 'Solid is an open source technology inspired and developed with Sir Tim Berners-Lee. People and organizations now own and control their data and can collaborate globally with fully interoperable data stored in Solid Pods.',
        img: 'solid-hero.png',
        videoId: '',
        buttons: [
          { label: 'What is Solid', path: '', id: 'what-is-solid' },
          { label: 'Own Your Data', path: '', id: 'own-your-data' },
          { label: 'More Secure', path: '', id: 'more-secure' },
          { label: 'Interoperable', path: '', id: 'fully-interoperable' },
          { label: 'Secure Sharing', path: '', id: 'secure-sharing' },
          { label: 'W3C Standards', path: '', id: 'uses-w3c' },
        ]
      },
      whatIsSolid: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'What is Solid?',
        paragraphs: [
          'Solid is a specification that lets people store their data securely in decentralized data stores called Pods. Pods are like secure personal web servers for data. When data is stored in someone\'s Pod, they control which people and applications can access it.',
          'Solid Pods are data sources independent of application providers, and store data in an interoperable format so that different applications can use the same data.'
        ],
        id: 'what-is-solid',
        image: 'interoperability.png',
        videoId: '',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        learnMoreLink: '',
        html: 
          '<div><a href="https://solidproject.org/" target="_blank" class="btn font-weight-bold btn-link btn-lg text-dark" target="_self" style="text-decoration: none; padding-left: 0px !important;">' +
          'Learn More ' +
          '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" class=""></path></svg></a></div>'
      },
	    ownYourData: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Own Your Data',
        paragraphs: [
          'Your data is valuable. Traditional big app silos are using your data in ways that potentially compromise your privacy and identity.',
          'With Solid Pods you own and control all your data and fully control access to your data by both other entities and apps. Period.'
        ],
        id: 'own-your-data',
        image: 'solid-pod-access-corp.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
        /*html:
          '<div>' + 
          ' <h5 class="mb-4">Your data is valuable. Big tech is offering solutions where they access and enrich themself from your data.' +
          ' <h5 class="mb-4">With TrinPod\u2122 you will 100% own your data, and 100% control access to your data. Period.</h5>' +
          '</div>',*/
        learnMoreLink: '',
	      html: 
	        '<div><a href="https://solidproject.org/TR/wac" target="_blank" class="btn font-weight-bold btn-link btn-lg text-light" target="_self" style="text-decoration: none; padding-left: 0px !important;">' +
          'Learn More ' +
          '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" class=""></path></svg></a></div>'
      },
      interoperable: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Fully Interoperable Data',
        paragraphs: [
          'Today\'s applications do not talk to each other. With Solid, all data stored in Solid Pods is accessed using open-source standards and interoperable data formats. Solid\'s ability to describe things and their relationships allows different applications to work with the same data.'
        ],
        id: 'fully-interoperable',
        image: 'interoperability.png',
        videoId: '',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
	      learnMoreLink: '', 
	      html:
          '<div><a href="https://solid.github.io/data-interoperability-panel/specification/" target="_blank" class="btn font-weight-bold btn-link btn-lg text-dark" target="_self" style="text-decoration: none; padding-left: 0px !important;">' +
          'Learn More ' +
          '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" class=""></path></svg></a></div>'	      
      },
      usesW3c: { 
        eyebrow: '',
        eyebrowIcon: '',
        /*headline: 'Uses Existing W3C Standards',
        paragraphs: [
          'Solid is based on open-source specifications, which means developers can build Solid apps that use interoperable data across a broad ecosystem.'
        ],*/
        headline: '',
        paragraphs: [],
        id: 'uses-w3c',
        image: 'solid-specs.png',
        videoId: '',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        learnMoreLink: '',
        html: 
          '<h1 class="mb-4">Uses Existing W3C Standards</h1>' +
          '<p class="lead">Solid is based on open-source specifications, which means developers can build Solid apps that use interoperable data across a broad ecosystem.</p>' +
          '<div><a href="https://solidproject.org/TR/" target="_blank" class="btn font-weight-bold btn-link btn-lg text-dark" target="_self" style="text-decoration: none; padding-left: 0px !important;">' +
          'Solid Project W3C Specifications ' +
              '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" class=""></path></svg></a></div>' +
	        '<div><a href="https://solidproject.org/developers/tools/" target="_blank" class="btn font-weight-bold btn-link btn-lg text-dark" target="_self" style="text-decoration: none; padding-left: 0px !important;">' +
          'Open Source Libraries & Tools ' +
              '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" class=""></path></svg></a></div>' +
          '<div><a href="https://github.com/inrupt/solid-client-authn-js" target="_blank" class="btn font-weight-bold btn-link btn-lg text-dark" target="_self" style="text-decoration: none; padding-left: 0px !important;">' +
          'Open Source Authentication Libraries ' +
              '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" class=""></path></svg></a></div>' +
	      '<div><a href="http://linkeddata.github.io/rdflib.js/doc/" target="_blank" class="btn font-weight-bold btn-link btn-lg text-dark" target="_self" style="text-decoration: none; padding-left: 0px !important;">' +
	      'Open Source Linked Data API for JavaScript (triplestore) ' +
              '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" class=""></path></svg></a></div>' +
        '<div><a href="https://fosdem.org/2023/schedule/event/sovcloud_from_zero_to_hero_with_solid/" target="_blank" class="btn font-weight-bold btn-link btn-lg text-dark" target="_self" style="text-decoration: none; padding-left: 0px !important;">' +
	      'From Zero to Hero with Solid ' +
              '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" class=""></path></svg></a></div>'
      },
    }
  }
};
</script>
